import { getSearchUser } from '@/api/course'
import to from 'await-to'
export default {
  state: {
    classLiveMsg: [],
  },
  mutations: {
    changeClassMsg(state, res) {
      if (res.message.type == 2) {
        let obj = {
          sourceMsg: res.message.message.sourceMsg,
          id: res.message.message.id,
          from: res.result,
          type: 2,
        }
        state.classLiveMsg.push(obj)
      }

      if (res.type == 1) {
        let obj = {
          sourceMsg: res.message,
          id: res.id,
          from: '',
          type: 1,
        }
        state.classLiveMsg.push(obj)
        console.log(state.classLiveMsg)
      }
    },
    clearMsg(state) {
      state.classLiveMsg = []
    },
  },
  actions: {
    async setChangeMsg({ commit }, formData) {
      if (formData.type == 2) {
        const [res, err] = await to(getSearchUser({ userImAccount: formData.message.from }))
        if (err) return
        commit('changeClassMsg', { message: formData, result: res.nickName })
      } else {
        commit('changeClassMsg', formData)
      }
    },
  },
}
